<template>
  <b-card no-body class="card-statistics">
    <b-card-header>
      <b-card-title>{{ t('TodaysReminder') }}</b-card-title>
      <b-card-text class="font-small-2 mr-25 mb-0" />
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col sm="12">
          <b-table-simple
            hover
            caption-top
            responsive
            class="rounded-bottom mb-0 table table-bordered"
          >
            <b-thead head-variant="light">
              <b-tr>
                <b-th>{{ t('Subject') }}</b-th>
                <b-th>{{ t('Purpose') }}</b-th>
                <b-th>{{ t('Outcome') }}</b-th>
                <b-th>{{ t('Date') }}</b-th>
                <b-th>{{ t('ContactName') }}</b-th>
                <b-th>{{ t('ContactEmail') }}</b-th>
                <b-th>{{ t('ContactPhone') }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(item, index) in todaysReminder" :key="index">
                <b-td
                  v-b-tooltip.hover
                  :title="item.subject_name || 'N/A'"
                  class="text-truncate"
                  style="max-width: 150px;"
                >
                  {{ item.subject_name || 'N/A' }}
                </b-td>
                <b-td
                  v-b-tooltip.hover
                  :title="item.purpose || 'N/A'"
                  class="text-truncate"
                  style="max-width: 150px;"
                >
                  {{ item.purpose || 'N/A' }}
                </b-td>
                <b-td
                  v-b-tooltip.hover
                  :title="item.outcome || 'N/A'"
                  class="text-truncate"
                  style="max-width: 150px;"
                >
                  {{ item.outcome || 'N/A' }}
                </b-td>
                <b-td
                  v-b-tooltip.hover
                  :title="dFormat(item.start_date_time) || 'N/A'"
                  class="text-truncate"
                  style="max-width: 150px;"
                >
                  {{ dFormat(item.start_date_time) || 'N/A' }}
                </b-td>
                <b-td
                  v-b-tooltip.hover
                  :title="item.contact_name || 'N/A'"
                  class="text-truncate"
                  style="max-width: 150px;"
                >
                  {{ item.contact_name || 'N/A' }}
                </b-td>
                <b-td
                  v-b-tooltip.hover
                  :title="item.contact_email || 'N/A'"
                  class="text-truncate"
                  style="max-width: 150px;"
                >
                  {{ item.contact_email || 'N/A' }}
                </b-td>
                <b-td
                  v-b-tooltip.hover
                  :title="item.contact_mobile || 'N/A'"
                  class="text-truncate"
                  style="max-width: 150px;"
                >
                  {{ item.contact_mobile || 'N/A' }}
                </b-td>
              </b-tr>
              <b-tr v-if="todaysReminder.length == 0">
                <b-td class="text-center" colspan="7">
                  {{ t('No Reminders') }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils } from '@/@core/libs/i18n'
import constants from '@/constants'
import store from '../../../store'
import { dFormat, hideLoader, showLoader } from '@/utils/common'
import 'bootstrap-vue'

export default {
  components: {},
  props: {},
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      todaysReminder: [],
    }
  },
  mounted() {
    this.getTodaysReminder()
  },
  methods: {
    dFormat(date) {
      return dFormat(date, 'DD MMMM YYYY hh:mm A')
    },
    getTodaysReminder() {
      showLoader()
      store.dispatch('DashboardApi/GetTodaysReminder').then(async response => {
        if (response.data.code === constants.SUCCESS) {
          this.todaysReminder = response.data.data
        }
        hideLoader()
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
